export const actionTypes = {
    GET_TREND_KPIS: 'eventDetails/trendSignal/GET_TREND_KPIS',
    ADD_SELECTED_TREND_KPI_DATA: 'eventlist/assistance/ADD_SELECTED_TREND_KPI_DATA',
    REMOVE_SELECTED_TREND_KPI_DATA: 'eventlist/assistance/REMOVE_SELECTED_TREND_KPI_DATA',
};

export const MAX_SELECTED_KPIS = 6;
